import React from 'react'
import PageComponent from '../../../../../component/common/Page-Component'
import { useParams } from 'react-router-dom'
import CONSTANTS from '../../../../../util/constant/CONSTANTS';
import moment from 'moment';
import { clubManagerExportData } from '../../../../../util/exportData';

const Manager = () => {
    const { id } = useParams();
    return (
        <div>
            <PageComponent
                tableTitle="Manager List"
                tableHeaders="CLUBS_STAFF"
                getAPI={CONSTANTS.API.getClubManager}
                extraParams={`&ClubId=${id}`}
                extraResData='managers'
                getData={(res) => {
                    // console.log(res);
                    return res?.map(data => {
                        return {
                            ...data,
                            no: `M${data?.id.toString().padStart(7, "0")}`,
                            clubName: data?.Club?.name,
                            staffs: 'Manager',
                            date: moment.utc(data?.createdAt).local().format('DD MMM, YYYY'),


                        }
                    })
                }}
                exportData={clubManagerExportData}
                exportCSV
            />

        </div>
    )
}

export default Manager